module.exports = __webpack_public_path__ + "img/index_wait_next.980f5748.png";